import { SolicitudSeccion } from "../common/enumModel";
import { IConfiguracionDocumentoModel } from "../interfaces/configuracion-documento/IConfiguracionDocumentoModel";

export class DocumentacionRequeridaModel implements IConfiguracionDocumentoModel {
  idSolicitud: number;
  idSolicitudDocumentoRequerido: number;
  
  idSolicitudPersonaDocumento: number;
  idSolicitudEquipoDocumento: number;
  idSolicitudVehiculoDocumento: number;

  idConfiguracionDocumento: number;
  idDocumento: number;
  idMaestroDocumento: number;
  documento: string;
  documentoRequerido: string;

  nombre: string;
  
  idRequisito : number;
  requisito: string;
  esPredeterminado: boolean;
  controlarFechas: boolean;
  restringeAccesos: boolean;
  seccion: SolicitudSeccion;
  nombreSeccion: string;

  esRequisitoBloqueado: boolean;

  nombreArchivo: string;
  rutaArchivo: string;

  aprobado: boolean;
  observado: boolean;
  idEstado: number;
  idTipoVisita: number;
  tipoVisita: string;

  EsEliminado: boolean;
  contieneDocumento: boolean;
  fechaVencimiento?: Date;
  esAdicional: boolean;
  permiteVisor: boolean;
  constructor() {
    this.idSolicitud = 0;
    this.idSolicitudDocumentoRequerido = 0;
    
    this.idSolicitudPersonaDocumento = 0;
    this.idSolicitudEquipoDocumento = 0;
    this.idSolicitudVehiculoDocumento = 0;

    this.idConfiguracionDocumento = 0;
    this.idDocumento = 0;
    this.nombre = '';
    this.idMaestroDocumento = 0;
    this.documento = '';
    this.documentoRequerido = '';
    this.idRequisito = 0;
    this.requisito = '';
    this.esPredeterminado = false;
    this.controlarFechas = false;
    this.restringeAccesos = false;
    this.seccion = SolicitudSeccion.DocumentacionTecnica;
    this.nombreSeccion = '';
    this.nombreArchivo = '';
    this.rutaArchivo = '';
    this.aprobado = false;
    this.observado = false;
    this.idEstado = 0;
    this.idTipoVisita = 0;
    this.tipoVisita = '';

    this.EsEliminado = false;
    this.esRequisitoBloqueado = false;
    this.contieneDocumento = false;
    this.esAdicional = false;
    this.permiteVisor = false;
  }
}
